/* utils */
import './scripts/utils/lazyloading';
import './scripts/accordion'
import './scripts/swatches'

/* vue */
import './vue/main';
import Vue from 'vue';

// Header
window.PSVueNav = new Vue({
	name: 'Header',
	el: '.full-header',
	components: {
		'instant-search': require('./vue/components/InstantSearch.vue').default,
	},
})

// Collection
window.PSVueCollection = new Vue({
	name: 'Collection',
	el: '.collection',
	components: {
		collection: require('./vue/components/Collection.vue').default,
	},
})

// Cart
window.PSVueCart = new Vue({
	name: 'Cart',
	el: '.cart',
	components: {
		cart: require('./vue/components/Cart.vue').default,
	},
})

// Product
if (document.body.classList.contains('template-product')) {
  let product_handle = document.querySelector('.product__container').dataset.productHandle;
  window.setSwatches(product_handle);

	window.PSVueProduct = new Vue({
		name: 'Product',
		components: {
			accordion: require('./vue/components/Accordion.vue').default,
			'accordion-item': require('./vue/components/AccordionItem.vue').default,
		},
		data() {
			return {
				product: {},
				variantSelected: null,
				quantity: 1,
				price: 0,
				productUnit: '',
				linealMeters: 1000,
				numOfLengths: 1,
				showPopup: false,
			}
		},
		mounted() {
			this.product = JSON.parse(this.$refs.productobj.innerHTML)
			this.variantSelected = this.product.variants[0].id
			if (this.$refs.kitboxscroll) {
				this.$refs.kitboxscroll.addEventListener(
					'scroll',
					function() {
						this.scrollTop == 0
							? this.lastChild.classList.add('scrollmore')
							: this.lastChild.classList.remove('scrollmore')
					},
					{
						passive: true,
					}
				)
			}
			fetch(`/products/${this.product.handle}?view=metafields`)
				.then((res) => res.json())
				.then((data) => {
					this.productUnit = data.unit.value;
				});
		},
		watch: {
			variantSelected: {
				handler() {
					if (!this.product.variants) return
					this.product.variants.forEach(v => {
						if (this.variantSelected == v.id) {
							this.price = v.price
						}
					})
				},
				immediate: true,
			},
			linealMeters() {
				this.quantity = Math.ceil((this.linealMeters * this.numOfLengths) / 1000)
				this.price = this.quantity * this.product.price
				this.$refs.quantity.value = this.quantity
			},
			numOfLengths() {
				this.quantity = Math.ceil((this.linealMeters * this.numOfLengths) / 1000)
				this.price = this.quantity * this.product.price
				this.$refs.quantity.value = this.quantity
			},
		},
		methods: {
			productAddedPopup() {
				this.showPopup = true
				setTimeout(() => {
					this.showPopup = false
				}, 2500)
			},
			decrement() {
				this.quantity = this.quantity === 1 ? 1 : this.quantity - 1
			},
		},
	}).$mount('.product__container')
}

// Account
window.PSVueAccount = new Vue({
	name: 'Account',
	el: '.account',
	delimiters: ['${', '}'],
	data() {
		return {
			accountState: '',
			newAddressOpen: false,
			editAddressID: 0,
		}
	},
	mounted() {
		this.$el.style.display = 'grid'
		this.accountState = window.location.pathname
	},
	watch: {
		accountState: {
			immediate: true,
			handler() {
				if (this.accountState == '/account/addresses') {
					setTimeout(() => {
						// Initialize listeners on address selectors, callback in shopify_common.js
						new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
							hideElement: 'AddressProvinceContainerNew',
						})
						// Initialize each edit form's country/province selector
						document.querySelectorAll('.address-country-option').forEach(option => {
							let formId = option.dataset.formId
							let countrySelector = 'AddressCountry_' + formId
							let provinceSelector = 'AddressProvince_' + formId
							let containerSelector = 'AddressProvinceContainer_' + formId
							new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
								hideElement: containerSelector,
							})
						})
					}, 3000)
				}
			},
		},
	},
	methods: {
		updateAccountState(pathname) {
			this.accountState = pathname
			let url = window.location.origin + this.accountState
			window.history.replaceState({ path: null }, '', url)
		},
		deleteAddress(formID) {
			Shopify.postLink('/account/addresses/' + formID, {
				parameters: {
					_method: 'delete',
				},
			})
		},
	},
})

// Standards & Guides
window.PSVueStandardsGuides = new Vue({
	name: 'Standards & Guides',
	components: {
		accordion: require('./vue/components/Accordion.vue').default,
		'accordion-item': require('./vue/components/AccordionItem.vue').default,
	},
}).$mount('.tactile-standards')

// Colour Contrast Calculator
window.PSVueContrastCalculator = new Vue({
	name: 'Colour Contrast',
	el: '.colour__calculator',
	data() {
		return {
			lrv1: 0,
			lrv2: 0,
			result: 0,
		}
	},
	methods: {
		calculate() {
			if (this.lrv1 > this.lrv2) {
				this.result = Number(((125 * (this.lrv1 - this.lrv2)) / (this.lrv1 + this.lrv2 + 25)).toFixed(1))
			} else {
				this.result = Number(((125 * (this.lrv2 - this.lrv1)) / (this.lrv2 + this.lrv1 + 25)).toFixed(1))
			}
		},
	},
})

// CMS Sidebar Pages
window.PSVueCMS = new Vue({
	name: 'CMS Page',
	el: '.sidebar-layout',
	components: {
		tabs: require('./vue/components/Tabs.vue').default,
		tab: require('./vue/components/Tab.vue').default,
		accordion: require('./vue/components/Accordion.vue').default,
		'accordion-item': require('./vue/components/AccordionItem.vue').default,
	},
	data() {
		return {
			faqTree: [],
			currentPath: window.location.pathname,
		}
	},
	mounted() {
		if (this.currentPath.includes('faq')) {
			let tabs = document.querySelectorAll('.faq-data h2')
			tabs.forEach((tab, idx) => {
				this.faqTree.push({
					tabTitle: tab.innerText,
					tabBody: [],
				})
				let questions = this.nextUntil(tab, 'h2', 'h3')
				questions.forEach(question => {
					let answer_arr = this.nextUntil(question, 'h3', 'p')
					let answer_html = ''
					answer_arr.forEach(el => {
						answer_html += el.outerHTML
					})
					this.faqTree[idx].tabBody.push({
						question: question.innerText,
						answer: answer_html,
					})
				})
			})
		}
	},
	methods: {
		nextUntil(elem, selector, filter) {
			let siblings = []
			elem = elem.nextElementSibling

			while (elem) {
				if (elem.matches(selector)) break
				if (filter && !elem.matches(filter)) {
					elem = elem.nextElementSibling
					continue
				}
				siblings.push(elem)
				elem = elem.nextElementSibling
			}

			return siblings
		},
	},
})
